import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
    return (
      <header>
        <Link to="/">
          <div className="logo">
            <img src="logo.png" alt="Logo" />
          </div>
        </Link>
        <nav>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/add-problem">Add Problem</Link>
            </li>
            <li>
              <Link to="/edit">Edit</Link>
            </li>
          </ul>
        </nav>
      </header>
    );
};

export default Header;